import { render, staticRenderFns } from "./InvoiceCategories.vue?vue&type=template&id=4980979a&"
import script from "./InvoiceCategories.vue?vue&type=script&lang=js&"
export * from "./InvoiceCategories.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceCategories.vue?vue&type=style&index=0&id=4980979a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports